import React, { useEffect } from 'react';
import EarningsReport from './EarningsReport';
import ForecastTable from './ForecastTable';
import { useParams } from 'react-router-dom';
import LoaderHelper from '../../utility/Loading/LoaderHelper';
import StockService from '../../Api_Module/Api_Services/StockService';

const AnalystForecasts = () => {
  const { symbol } = useParams<{
    symbol?: string;
  }>();

  const metrics = [{
    id: 'revenue',
    name: 'Revenue'
  }, {
    id: 'revenueGrowth',
    name: 'Revenue Growth'
  }, {
    id: 'eps',
    name: 'EPS'
  }, 
  {
    id: 'epsGrowth',
    name: 'EPS Growth'
  }, 
  {
    id: 'forwardPE',
    name: 'Forward PE'
  }, 
  {
    id: 'revenueBeatOrMiss',
    name: 'Revenue Beat/Miss'
  }, {
    id: "epsBeatOrMiss",
    name: 'EPS Beat/Miss'
  }];
  const [fiscalYears, setFiscalYears] = React.useState<any[]>([]);
  const [data, setData] = React.useState<any[]>([]);
  const [recentEarningsAIReport, setRecentEarningsAIReport] = React.useState<any>({});
  const [earningsLabel, setEarningsLabel] = React.useState<string>('');
  const [transcript, setTranscript] = React.useState<string>('');

  useEffect(() => {
    if (!fiscalYears || fiscalYears.length === 0) {
      getAnalystForecasts("annual");
    }
  }, [fiscalYears]);

  // ============================================
  // FEATURE TEMPORARILY DISABLED - Earnings AI Report API
  // Date disabled: January 23, 2026
  // Causing 500 Internal Server Error
  // Component already disabled in render, this prevents API call
  // To re-enable: Uncomment the useEffect below
  // ============================================

  // useEffect(() => {
  //   if (symbol) {
  //     getRecentEarningsAIReport();
  //   }
  // }, [symbol]);

  const getRecentEarningsAIReport = async () => {
    try {
      LoaderHelper.loaderStatus(true);
      const result = await StockService.getRecentEarningsAIReport(symbol);
      if (result) {
        let parsedReport: any = null;
        if (result.aiReport) {
          try {
            parsedReport = typeof result.aiReport === 'string' ? JSON.parse(result.aiReport) : result.aiReport;
          } catch (e) {
            parsedReport = null;
            console.warn('Failed to parse aiReport JSON:', e);
          }
        }
        const categories = parsedReport?.categories || result.categories || {};
        setRecentEarningsAIReport(categories);
        const incomingLabel = parsedReport?.displayLabel || result.displayLabel;
        if (incomingLabel) setEarningsLabel(incomingLabel);
        const incomingTranscript = parsedReport?.transcript || result.transcript;
        if (incomingTranscript) setTranscript(incomingTranscript);
      }
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      console.error("Error fetching recent earnings AI report:", error);
      LoaderHelper.loaderStatus(false);
    }
  };

  const getAnalystForecasts = async (period: string) => {
    try {
      LoaderHelper.loaderStatus(true);
      const result = await StockService.getAnalystForecastsWithOut(symbol, period);
      LoaderHelper.loaderStatus(false);
      if (result.forecasts && result.forecasts.length > 0) {
        const data:any = [];
        result.forecasts.forEach((forecast: any) => {
          metrics.forEach((metric:any) => {
            if (!data[metric.id]) {
              data[metric.id] = {};
            }
            data[metric.id][forecast.periodLabel] = forecast[metric.id]?.formattedValue || '-';
          });
        });
        setData(data);
        setFiscalYears(result.forecasts.map((forecast: any) => ({
          year: forecast.fiscalYear,
          label: forecast.periodLabel,
          date: forecast.periodEnding,
          historical: forecast.fiscalYear <= new Date().getFullYear(),
        })));
      }
    } catch (error) {
      console.error("Error fetching analyst forecasts:", error);
    }
  };

  const handlePeriodChange = (period: string) => {
    getAnalystForecasts(period);
  }

  return <div className="space-y-4">
      {/* ============================================
          FEATURE TEMPORARILY DISABLED - Recent Earnings Report
          To re-enable: Uncomment the line below
          Date disabled: January 23, 2026
          ============================================ */}
      {/* <EarningsReport sections={recentEarningsAIReport} displayLabel={earningsLabel} transcript={transcript} /> */}
      <ForecastTable fiscalYears={fiscalYears} metrics={metrics} data={data} handlePeriodChange={handlePeriodChange} />
    </div>;
}

export default AnalystForecasts;